import React from 'react';
import { Popover, useTheme } from '@material-ui/core';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import { StyledText } from './StyledText';

const MatchCountInfoIcon = () => {
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);
  const theme = useTheme();
  const handlePopoverOpen = (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const popoverId = open ? 'info-popover' : undefined;

  return (
    <>
      <div
        aria-owns={popoverId}
        aria-haspopup='true'
        onMouseEnter={handlePopoverOpen}
        onMouseLeave={handlePopoverClose}
        style={{ width: '100%', height: '100%', position: 'relative' }}
      >
        <InfoOutlinedIcon style={{ fill: theme.palette.primary.main, fontSize: 18, bottom: 0, left: 0, position: 'absolute' }} />
      </div>
      <Popover
        id={popoverId}
        open={open}
        style={{ pointerEvents: 'none' }}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left'
        }}
        onClose={handlePopoverClose}
        disableRestoreFocus
      >
        <StyledText style={{ padding: 10 }}>The number of other investors in the matched list who the connector is connected with.</StyledText>
      </Popover>
    </>
  );
};

export default MatchCountInfoIcon;
